import { v4 as uuid } from "uuid";
import { z } from "zod";
import { EmissionFactorType } from "../../entities/emissionFactor";
export const emissionFactorLineItemSchema = z.object({
    created: z.date(),
    emissionFactorType: z.enum(EmissionFactorType),
    id: z.string(),
    projectId: z.string(),
    value: z.number()
});
export const createDefaultEmissionFactorLineItem = (projectId, emissionFactorType) => emissionFactorLineItemSchema.parse({
    created: new Date(),
    emissionFactorType,
    id: uuid(),
    projectId,
    value: 0
});
